module.exports = __webpack_public_path__ + "assets/media/evening.00aa1811.mp3";